import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { TenantDto } from '@picflow/types';
import { BrowserService } from '../../services/browser.service';
import { PublicTenantService } from '../../services/public-tenant.service';
import { RedirectService } from '../../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileGuard {
  private publicTenantService = inject(PublicTenantService);
  private browserService = inject(BrowserService);
  private redirectService = inject(RedirectService);

  async canActivate(): Promise<UrlTree | boolean> {
    const subDomain = this.browserService.getTenantSubDomain();
    const customDomain = this.browserService.getTenantCustomDomain();

    try {
      let tenant: TenantDto;

      if (customDomain) {
        tenant = await this.publicTenantService.getTenantFromCustomDomain(customDomain);
      } else {
        tenant = await this.publicTenantService.getTenant(subDomain);
      }

      if (tenant && !tenant?.block_public_link_access) {
        return true;
      }
      return this.redirectService.externalRedirectTo(this.browserService.getCorrectPicflowUrl());
    } catch (error) {
      if (!(error instanceof HttpErrorResponse)) throw error;
      if (error.status !== 503) throw error;
      return this.redirectService.redirectTo(['/maintenance']);
    }
  }
}
